import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
  Menu, X, Shield, Server, Phone, Code, ShoppingCart, Lock,
  ChevronDown, Mail, MapPin, Globe, Twitter, Linkedin,
  Users, Award, CheckCircle, ArrowRight, Hexagon, Building2,
  Target, Eye, Briefcase, Network, Cloud, Database, Monitor,
  Smartphone, Wifi, Settings, BarChart3, FileText, CheckSquare,
  Calendar, DollarSign, TrendingUp, UserCheck, Clock, Lightbulb,
  Share2, Sun, Zap, Play
} from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../components/ui/dialog';

const Home = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you! Your message has been sent.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const businessSolutions = [
    {
      icon: Server,
      title: 'Managed Services',
      description: 'Our engineers provide expert technical support in both government and business environments, with experience in various help desk platforms.'
    },
    {
      icon: Network,
      title: 'Network Solution',
      description: 'With over 15 years of experience, we build secure telecom and network infrastructure globally, including in challenging terrains.'
    },
    {
      icon: Code,
      title: 'Software Development',
      description: 'Whether you need a custom web or mobile application, enterprise software, or a specialized product, we\'ve got you covered.'
    },
    {
      icon: Cloud,
      title: 'Cloud Solutions',
      description: 'As an indirect Microsoft cloud solution partner, we offer a range of functionalities to support and grow your cloud-based business operations.'
    }
  ];

  const certifications = ['AGILE', 'CSL', 'ITIE', 'PMP', 'MCITP', 'MCDBA', 'MCSE', 'MCSD'];

  const clientLogos = [
    { name: 'Microsoft', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-frontend/artifacts/8w0s030a_Microsoft_logo_%282012%29.svg.png' },
    { name: 'Vodafone', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-frontend/artifacts/bgebtpvs_Vodafone-Logo-2006-2017.png' },
    { name: 'HP', logo: 'https://logo.clearbit.com/hp.com' },
    { name: 'Dell', logo: 'https://logo.clearbit.com/dell.com' },
    { name: 'Google', logo: 'https://logo.clearbit.com/google.com' },
    { name: 'Coca-Cola', logo: 'https://logo.clearbit.com/coca-cola.com' },
    { name: 'Ford', logo: 'https://logo.clearbit.com/ford.com' },
    { name: 'Nokia', logo: 'https://logo.clearbit.com/nokia.com' },
    { name: 'Client 1', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/kmbz8vp6_2.png' },
    { name: 'Client 2', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/rnw6m171_3.png' },
    { name: 'Client 3', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/6ysx3525_4.png' },
    { name: 'Client 4', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/6d6pnnb6_1630616131420.jpeg' },
    { name: 'Client 5', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/fvs6q2e7_1631309571602.jpeg' },
    { name: 'BlueGrass Group', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/5a56iuhf_bluegrass-group-limited-583570.jpg' },
    { name: 'Client 6', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/wupepvoq_https___cdn.evbuc.com_images_634656849_897425418763_1_original.jpeg' },
    { name: 'Client 7', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/i3kw0tzg_images%20%281%29.jpeg' },
    { name: 'Client 8', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/7948ydt0_images.jpeg' },
    { name: 'Client 9', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/bgvc0oeu_images.png' },
    { name: 'Client 10', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-frontend/artifacts/nbjead8s_WhatsApp%20Image%202025-11-10%20at%2020.54.22_21ecfe12.jpg' },
    { name: 'Client 11', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-frontend/artifacts/3mx6bqo7_WhatsApp%20Image%202025-11-10%20at%2020.54.22_5bd51400.jpg' },
    { name: 'Client 12', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-frontend/artifacts/rl91f8ss_WhatsApp%20Image%202025-11-10%20at%2018.45.31_8ba50d60.jpg' },
    { name: 'Client 13', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-frontend/artifacts/oi0msv3g_WhatsApp%20Image%202025-11-10%20at%2018.45.31_93c7a2a2.jpg' },
    { name: 'Client 14', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-frontend/artifacts/k1bxzj3x_WhatsApp%20Image%202025-11-10%20at%2018.45.31_157961bb.jpg' },
    { name: 'Fonpack', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-frontend/artifacts/mntt0qec_fonpacklogodark-556x134x0x0x556x134x1664807516.png' },
    { name: 'Eden Heights', logo: 'https://customer-assets.emergentagent.com/job_hyperlink-frontend/artifacts/86rg08la_eden-heights-logo_2.png' }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/0iy7o1s0_cropped-HYPERLINK_transperat.webp"
                alt="Hyperlink Network Systems"
                className="h-20 w-20 object-contain"
              />
            </div>

            <nav className="hidden md:flex items-center space-x-8">
              <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-[#18246F] transition-colors font-medium">Home</button>
              <Link to="/about" className="text-gray-700 hover:text-[#18246F] transition-colors font-medium">About</Link>
              <Link to="/services" className="text-gray-700 hover:text-[#18246F] transition-colors font-medium">Services</Link>
              <Link to="/projects" className="text-gray-700 hover:text-[#18246F] transition-colors font-medium">Projects</Link>
              <Link to="/team" className="text-gray-700 hover:text-[#18246F] transition-colors font-medium">Team</Link>
              <Link to="/contact" className="text-gray-700 hover:text-[#18246F] transition-colors font-medium">Contact</Link>
              <Button onClick={() => navigate('/contact')} className="bg-[#3C74FF] hover:bg-[#2d5fd9] text-white">Let's Connect</Button>
            </nav>

            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden text-gray-700">
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden bg-white border-t">
            <div className="px-4 py-4 space-y-3">
              <button onClick={() => scrollToSection('home')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg">Home</button>
              <Link to="/about" className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg">About</Link>
              <Link to="/services" className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg">Services</Link>
              <Link to="/projects" className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg">Projects</Link>
              <Link to="/team" className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg">Team</Link>
              <Link to="/contact" className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg">Contact</Link>
              <Button onClick={() => navigate('/contact')} className="w-full bg-[#3C74FF] hover:bg-[#2d5fd9] text-white">Let's Connect</Button>
            </div>
          </div>
        )}
      </header>

      {/* Hero Section - Animated */}
      <section id="home" className="relative h-screen overflow-hidden bg-gradient-to-br from-[#0a0e27] via-[#18246F] to-[#2d3a8c]">
        {/* Animated Background Grid */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0" style={{
            backgroundImage: 'linear-gradient(rgba(60, 116, 255, 0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(60, 116, 255, 0.3) 1px, transparent 1px)',
            backgroundSize: '50px 50px',
            animation: 'gridMove 20s linear infinite'
          }}></div>
        </div>

        {/* Floating Tech Icons */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 left-10 animate-float">
            <div className="bg-[#3C74FF]/20 backdrop-blur-sm p-4 rounded-2xl border border-[#3C74FF]/30">
              <Network className="text-[#3C74FF]" size={32} />
            </div>
          </div>
          <div className="absolute top-40 right-20 animate-float-delayed">
            <div className="bg-[#3C74FF]/20 backdrop-blur-sm p-4 rounded-2xl border border-[#3C74FF]/30">
              <Cloud className="text-[#3C74FF]" size={32} />
            </div>
          </div>
          <div className="absolute bottom-40 left-20 animate-float-slow">
            <div className="bg-[#3C74FF]/20 backdrop-blur-sm p-4 rounded-2xl border border-[#3C74FF]/30">
              <Shield className="text-[#3C74FF]" size={32} />
            </div>
          </div>
          <div className="absolute bottom-32 right-32 animate-float">
            <div className="bg-[#3C74FF]/20 backdrop-blur-sm p-4 rounded-2xl border border-[#3C74FF]/30">
              <Server className="text-[#3C74FF]" size={32} />
            </div>
          </div>
          <div className="absolute top-1/3 left-1/4 animate-float-delayed">
            <div className="bg-[#3C74FF]/20 backdrop-blur-sm p-3 rounded-xl border border-[#3C74FF]/30">
              <Database className="text-[#3C74FF]" size={24} />
            </div>
          </div>
          <div className="absolute top-1/2 right-1/4 animate-float-slow">
            <div className="bg-[#3C74FF]/20 backdrop-blur-sm p-3 rounded-xl border border-[#3C74FF]/30">
              <Wifi className="text-[#3C74FF]" size={24} />
            </div>
          </div>
        </div>

        {/* Animated Particles */}
        <div className="absolute inset-0">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-[#3C74FF] rounded-full animate-particle"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${5 + Math.random() * 10}s`
              }}
            ></div>
          ))}
        </div>

        {/* Hero Content */}
        <div className="relative z-10 h-full flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <div className="max-w-4xl mx-auto text-center" style={{ paddingTop: '100px' }}>
              {/* Badge */}
              <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-3 py-1.5 mb-4 animate-fade-in">
                <Zap className="text-yellow-400" size={16} />
                <span className="text-white text-xs font-medium">20+ Years of Excellence in IT Solutions</span>
              </div>

              {/* Main Heading */}
              <h1 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight animate-slide-up">
                Technology with
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#3C74FF] via-[#60A5FA] to-[#93C5FD] animate-gradient">
                  Infinite Solutions
                </span>
              </h1>

              {/* CTA Buttons */}
              <div className="flex flex-wrap gap-3 justify-center animate-slide-up-delayed">
                <Button 
                  onClick={() => scrollToSection('contact')}
                  size="default"
                  className="bg-[#3C74FF] hover:bg-[#2d5fd9] text-white px-6 py-4 text-base group"
                >
                  Get Started
                  <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={16} />
                </Button>
                <Button 
                  onClick={() => scrollToSection('about')}
                  size="default"
                  variant="outline"
                  className="border-2 border-white/30 text-white hover:bg-white/10 backdrop-blur-sm px-6 py-4 text-base"
                >
                  Learn More
                </Button>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-6 mt-10 pt-10 border-t border-white/20 animate-fade-in-delayed max-w-2xl mx-auto">
                <div>
                  <div className="text-2xl md:text-3xl font-bold text-white mb-1">150+</div>
                  <div className="text-xs text-gray-400">Projects Delivered</div>
                </div>
                <div>
                  <div className="text-2xl md:text-3xl font-bold text-white mb-1">50+</div>
                  <div className="text-xs text-gray-400">Happy Clients</div>
                </div>
                <div>
                  <div className="text-2xl md:text-3xl font-bold text-white mb-1">24/7</div>
                  <div className="text-xs text-gray-400">Support Available</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Our Company - Page 2 Design */}
      <section id="about" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-[#18246F] mb-8">About Our Company</h2>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="bg-[#616EB7] p-4 rounded-lg flex-shrink-0">
                    <Lightbulb className="text-yellow-400" size={24} />
                  </div>
                  <p className="text-gray-700 leading-relaxed text-justify">
                    HYPERLINK NETWORK SYSTEMS (HNS) is an information systems company specializing in network and telecommunication management.
                  </p>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <CheckCircle className="text-blue-600" size={24} />
                  </div>
                  <p className="text-gray-700 leading-relaxed text-justify">
                    Our journey over the past decade has been focused on delivering solutions and building partnerships. This has enabled us to create an environment where our customers have become part of our family.
                  </p>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <CheckCircle className="text-blue-600" size={24} />
                  </div>
                  <p className="text-gray-700 leading-relaxed text-justify">
                    For more than 10 years, Hyperlink Network Systems (HNS) has helped organizations navigate daily business challenges by creating secure IT-based solutions that transform business processes, people, technologies, and customer experiences.
                  </p>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="bg-[#3C74FF] p-4 rounded-lg flex-shrink-0">
                    <Briefcase className="text-white" size={24} />
                  </div>
                  <p className="text-gray-700 leading-relaxed text-justify">
                    We have delivered custom-fit solutions across the country and proudly consider ourselves one of the best IT solution providers in the region.
                  </p>
                </div>
              </div>
            </div>

            <div className="relative group cursor-pointer" onClick={() => setIsVideoOpen(true)}>
              <img 
                src="https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/mtjez97o_WhatsApp%20Image%202025-11-08%20at%2002.29.26_82f8df31.jpg"
                alt="Team Working"
                className="rounded-2xl shadow-2xl grayscale group-hover:grayscale-0 transition-all duration-500"
              />
              {/* Video Play Button Overlay */}
              <div className="absolute inset-0 flex items-center justify-center rounded-2xl">
                <div className="bg-white/90 backdrop-blur-sm rounded-full p-4 shadow-lg transform group-hover:scale-110 transition-transform duration-300">
                  <Play className="text-[#3C74FF]" size={32} fill="#3C74FF" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Modal */}
      <Dialog open={isVideoOpen} onOpenChange={setIsVideoOpen}>
        <DialogContent className="max-w-4xl w-full p-0 bg-black border-0">
          <DialogHeader className="sr-only">
            <DialogTitle>Company Video</DialogTitle>
          </DialogHeader>
          <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
            <video
              className="absolute top-0 left-0 w-full h-full"
              controls
              autoPlay
              src="https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/icxmhaoa_video.mp4"
            >
              Your browser does not support the video tag.
            </video>
          </div>
          <button
            onClick={() => setIsVideoOpen(false)}
            className="absolute top-4 right-4 text-white bg-black/50 rounded-full p-2 hover:bg-black/70 transition-colors z-10"
          >
            <X size={24} />
          </button>
        </DialogContent>
      </Dialog>

      {/* Why Choose Our Company - Redesigned Modern Section */}
      <section className="py-20 bg-gradient-to-br from-white via-blue-50/30 to-purple-50/30 relative overflow-hidden">
        {/* Background Decorative Elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#3C74FF]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#616EB7]/5 rounded-full blur-3xl"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          {/* Section Header */}
          <div className="text-center mb-16">
            <Badge className="mb-4 bg-[#3C74FF]/10 text-[#3C74FF] border-[#3C74FF]/20">Why Choose Us</Badge>
            <h2 className="text-4xl md:text-5xl font-bold text-[#18246F] mb-4">
              Your Trusted Technology <span className="text-[#3C74FF]">Partner</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Building lasting relationships through innovation, expertise, and unwavering commitment to excellence
            </p>
          </div>

          {/* Stats Cards Row */}
          <div className="grid md:grid-cols-3 gap-6 mb-16">
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 duration-300 border border-gray-100">
              <div className="flex items-center justify-between mb-4">
                <div className="bg-gradient-to-br from-[#3C74FF] to-[#616EB7] text-white rounded-xl p-3">
                  <Users size={28} />
                </div>
                <span className="text-3xl font-bold text-[#3C74FF]">50+</span>
              </div>
              <h3 className="font-bold text-[#18246F] mb-2">Trusted Clients</h3>
              <p className="text-sm text-gray-600">Organizations trust us with their IT technology management</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 duration-300 border border-gray-100">
              <div className="flex items-center justify-between mb-4">
                <div className="bg-gradient-to-br from-[#616EB7] to-[#3C74FF] text-white rounded-xl p-3">
                  <Calendar size={28} />
                </div>
                <span className="text-3xl font-bold text-[#616EB7]">10+</span>
              </div>
              <h3 className="font-bold text-[#18246F] mb-2">Years Experience</h3>
              <p className="text-sm text-gray-600">Consistently serving and building trust in the Ghanaian market</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 duration-300 border border-gray-100">
              <div className="flex items-center justify-between mb-4">
                <div className="bg-gradient-to-br from-green-500 to-green-600 text-white rounded-xl p-3">
                  <CheckCircle size={28} />
                </div>
                <span className="text-3xl font-bold text-green-600">100%</span>
              </div>
              <h3 className="font-bold text-[#18246F] mb-2">Client Satisfaction</h3>
              <p className="text-sm text-gray-600">Delivering cutting-edge solutions that exceed expectations</p>
            </div>
          </div>

          {/* Main Content Grid */}
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left: Feature Cards */}
            <div className="space-y-4">
              <div className="group bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border-l-4 border-[#3C74FF] hover:translate-x-2">
                <div className="flex items-start space-x-4">
                  <div className="bg-[#3C74FF]/10 rounded-lg p-3 flex-shrink-0 group-hover:bg-[#3C74FF] transition-colors duration-300">
                    <Briefcase className="text-[#3C74FF] group-hover:text-white transition-colors" size={24} />
                  </div>
                  <div>
                    <h3 className="font-bold text-[#18246F] mb-2 text-lg">Strong Business Relationships</h3>
                    <p className="text-gray-600 text-sm text-justify">At HNS, we place great value on our business relationships. We've built trust within the market through consistent, reliable service.</p>
                  </div>
                </div>
              </div>

              <div className="group bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border-l-4 border-[#616EB7] hover:translate-x-2">
                <div className="flex items-start space-x-4">
                  <div className="bg-[#616EB7]/10 rounded-lg p-3 flex-shrink-0 group-hover:bg-[#616EB7] transition-colors duration-300">
                    <Code className="text-[#616EB7] group-hover:text-white transition-colors" size={24} />
                  </div>
                  <div>
                    <h3 className="font-bold text-[#18246F] mb-2 text-lg">Extensive Software Expertise</h3>
                    <p className="text-gray-600 text-sm text-justify">Deep experience in software development and help desk support services across diverse industries and sectors.</p>
                  </div>
                </div>
              </div>

              <div className="group bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border-l-4 border-purple-500 hover:translate-x-2">
                <div className="flex items-start space-x-4">
                  <div className="bg-purple-500/10 rounded-lg p-3 flex-shrink-0 group-hover:bg-purple-500 transition-colors duration-300">
                    <Network className="text-purple-500 group-hover:text-white transition-colors" size={24} />
                  </div>
                  <div>
                    <h3 className="font-bold text-[#18246F] mb-2 text-lg">Secure Network Specialists</h3>
                    <p className="text-gray-600 text-sm text-justify">We specialize in building secure networks and offer comprehensive support and management for any network environment.</p>
                  </div>
                </div>
              </div>

              <div className="group bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border-l-4 border-green-500 hover:translate-x-2">
                <div className="flex items-start space-x-4">
                  <div className="bg-green-500/10 rounded-lg p-3 flex-shrink-0 group-hover:bg-green-500 transition-colors duration-300">
                    <TrendingUp className="text-green-500 group-hover:text-white transition-colors" size={24} />
                  </div>
                  <div>
                    <h3 className="font-bold text-[#18246F] mb-2 text-lg">Cutting-Edge Solutions</h3>
                    <p className="text-gray-600 text-sm text-justify">Completed numerous IT infrastructure projects and continue providing innovative solutions to meet evolving market demands.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Image */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src="https://customer-assets.emergentagent.com/job_hyperlink-frontend/artifacts/hp78jpoz_ChatGPT%20Image%20Nov%2011%2C%202025%2C%2003_33_16%20AM.png"
                  alt="Technology"
                  className="w-full h-[600px] object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Company - Framed Design */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Main Frame Container */}
          <div className="bg-white rounded-3xl shadow-2xl border-4 border-[#3C74FF]/20 overflow-hidden">
            <div className="grid lg:grid-cols-2">
              {/* Left Side - Image */}
              <div className="relative h-full min-h-[600px]">
                <img 
                  src="https://customer-assets.emergentagent.com/job_hyperlink-frontend/artifacts/aun1gxv4_121.jpg"
                  alt="Global Presence"
                  className="w-full h-full object-cover grayscale"
                />
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-white/20"></div>
                
                {/* Badge */}
                <div className="absolute top-8 left-8">
                  <div className="bg-[#3C74FF] text-white px-6 py-3 rounded-full font-bold text-sm shadow-lg flex items-center space-x-2">
                    <Globe size={20} />
                    <span>WE ARE GLOBAL</span>
                  </div>
                </div>

                {/* Stats Overlay */}
                <div className="absolute bottom-8 left-8 right-8">
                  <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-xl">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <div className="text-3xl font-bold text-[#3C74FF]">2004</div>
                        <div className="text-sm text-gray-600">Established</div>
                      </div>
                      <div>
                        <div className="text-3xl font-bold text-[#3C74FF]">150+</div>
                        <div className="text-sm text-gray-600">Projects</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Side - Content */}
              <div className="p-12 bg-gradient-to-br from-white to-blue-50/30">
                {/* Header */}
                <div className="mb-8">
                  <div className="inline-block bg-[#3C74FF]/10 text-[#3C74FF] px-4 py-2 rounded-full text-sm font-semibold mb-4">
                    About Us
                  </div>
                  <h2 className="text-4xl font-bold text-[#18246F] mb-4">Our Company</h2>
                  <div className="w-20 h-1 bg-gradient-to-r from-[#3C74FF] to-[#616EB7]"></div>
                </div>

                {/* Content Cards */}
                <div className="space-y-6">
                  {/* Card 1 */}
                  <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
                    <div className="flex items-start space-x-4">
                      <div className="bg-[#3C74FF]/10 rounded-lg p-3 flex-shrink-0">
                        <Building2 className="text-[#3C74FF]" size={24} />
                      </div>
                      <p className="text-gray-700 leading-relaxed text-justify text-sm">
                        Although incorporated in 2004, Hyperlink Network Systems is rapidly becoming one of the top providers of IT and general office equipment in the country. We have successfully executed projects for both private and public-sector organizations.
                      </p>
                    </div>
                  </div>

                  {/* Card 2 - Mission */}
                  <div className="bg-gradient-to-br from-[#3C74FF] to-[#616EB7] rounded-xl p-6 shadow-md text-white">
                    <div className="flex items-start space-x-4">
                      <div className="bg-white/20 rounded-lg p-3 flex-shrink-0">
                        <Target className="text-white" size={24} />
                      </div>
                      <div>
                        <h3 className="font-bold text-lg mb-2">Our Mission</h3>
                        <p className="text-white/90 leading-relaxed text-justify text-sm">
                          To help optimize our clients' productivity by providing real-time, world-class, reliable, cost-effective, and complete information and communication technology solutions.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Card 3 */}
                  <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
                    <div className="flex items-start space-x-4">
                      <div className="bg-green-500/10 rounded-lg p-3 flex-shrink-0">
                        <Award className="text-green-600" size={24} />
                      </div>
                      <p className="text-gray-700 leading-relaxed text-justify text-sm">
                        With 150+ custom solutions and products successfully developed, and a presence in major global regions—including the US, West Africa, and the Middle East—we aim to become global leaders in custom software solutions, data security solutions, and enterprise mobility solutions.
                      </p>
                    </div>
                  </div>
                </div>

                {/* CTA Button */}
                <div className="mt-8">
                  <Button 
                    onClick={() => scrollToSection('contact')}
                    className="bg-[#3C74FF] hover:bg-[#2d5fd9] text-white rounded-full px-8 py-6 shadow-lg group"
                  >
                    Learn More About Us
                    <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision - Modern Redesign */}
      <section className="py-20 bg-gradient-to-br from-[#18246F] via-[#293074] to-[#3d4a8f] relative overflow-hidden">
        {/* Animated Background */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-72 h-72 bg-white rounded-full blur-3xl animate-pulse-slow"></div>
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#3C74FF] rounded-full blur-3xl animate-pulse-slower"></div>
        </div>

        {/* Floating Hexagons */}
        <div className="absolute inset-0 overflow-hidden opacity-5">
          <Hexagon className="absolute top-10 right-1/4 animate-float" size={100} />
          <Hexagon className="absolute bottom-20 left-1/4 animate-float" size={80} style={{ animationDelay: '2s' }} />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          {/* Section Header */}
          <div className="text-center mb-16">
            <Badge className="mb-4 bg-white/20 text-white border-white/30">Our Purpose</Badge>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Mission & <span className="text-[#3C74FF]">Vision</span>
            </h2>
            <p className="text-lg text-white/80 max-w-2xl mx-auto">
              Guiding principles that drive our commitment to excellence and innovation in technology solutions
            </p>
          </div>

          {/* Main Content Grid */}
          <div className="grid lg:grid-cols-3 gap-8 mb-12">
            {/* Mission Card */}
            <div className="lg:col-span-1">
              <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-300 h-full group">
                <div className="flex flex-col h-full">
                  <div className="mb-6">
                    <div className="bg-gradient-to-br from-[#3C74FF] to-[#616EB7] w-16 h-16 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                      <Target className="text-white" size={32} />
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-2">Mission</h3>
                    <div className="w-16 h-1 bg-gradient-to-r from-[#3C74FF] to-transparent"></div>
                  </div>
                  <p className="text-white/90 leading-relaxed text-justify flex-grow">
                    To lead the ICT industry in the reliable provision of information systems solutions and to be globally recognized for our incomparably high-quality and premium services.
                  </p>
                  <div className="mt-6 pt-6 border-t border-white/20">
                    <div className="flex items-center text-white/70 text-sm">
                      <CheckCircle size={16} className="mr-2" />
                      <span>Industry Leadership</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Vision Card */}
            <div className="lg:col-span-1">
              <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-300 h-full group">
                <div className="flex flex-col h-full">
                  <div className="mb-6">
                    <div className="bg-gradient-to-br from-[#616EB7] to-[#3C74FF] w-16 h-16 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                      <Eye className="text-white" size={32} />
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-2">Vision</h3>
                    <div className="w-16 h-1 bg-gradient-to-r from-[#616EB7] to-transparent"></div>
                  </div>
                  <p className="text-white/90 leading-relaxed text-justify flex-grow">
                    To help optimize our clients' productivity through the provision of real-time, world-class, reliable, cost-effective, and comprehensive information and communication technology solutions.
                  </p>
                  <div className="mt-6 pt-6 border-t border-white/20">
                    <div className="flex items-center text-white/70 text-sm">
                      <CheckCircle size={16} className="mr-2" />
                      <span>Client Success Focus</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Certifications Card */}
            <div className="lg:col-span-1">
              <div className="bg-gradient-to-br from-[#3C74FF] to-[#616EB7] rounded-3xl p-8 border border-white/30 h-full shadow-2xl">
                <div className="flex flex-col h-full">
                  <div className="mb-6">
                    <div className="bg-white/20 w-16 h-16 rounded-2xl flex items-center justify-center mb-4">
                      <Award className="text-white" size={32} />
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-2">Certifications</h3>
                    <div className="w-16 h-1 bg-white/40"></div>
                  </div>
                  <div className="grid grid-cols-2 gap-3 flex-grow">
                    {certifications.map((cert, index) => (
                      <div 
                        key={index} 
                        className="bg-white/10 backdrop-blur-sm rounded-lg px-3 py-2 flex items-center space-x-2 hover:bg-white/20 transition-colors duration-300"
                      >
                        <CheckCircle size={14} className="text-white flex-shrink-0" />
                        <span className="text-sm text-white font-medium">{cert}</span>
                      </div>
                    ))}
                  </div>
                  <div className="mt-6 pt-6 border-t border-white/20">
                    <p className="text-white/80 text-sm">Certified excellence in technology delivery</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section - Values & Image */}
          <div className="grid lg:grid-cols-2 gap-8">
            {/* Core Values */}
            <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20">
              <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
                <Lightbulb className="mr-3 text-[#3C74FF]" size={28} />
                Our Core Values
              </h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white/5 rounded-xl p-4 hover:bg-white/10 transition-colors">
                  <Shield className="text-[#3C74FF] mb-2" size={24} />
                  <h4 className="text-white font-semibold mb-1">Reliability</h4>
                  <p className="text-white/70 text-sm">Consistent, dependable service delivery</p>
                </div>
                <div className="bg-white/5 rounded-xl p-4 hover:bg-white/10 transition-colors">
                  <TrendingUp className="text-[#3C74FF] mb-2" size={24} />
                  <h4 className="text-white font-semibold mb-1">Innovation</h4>
                  <p className="text-white/70 text-sm">Cutting-edge technology solutions</p>
                </div>
                <div className="bg-white/5 rounded-xl p-4 hover:bg-white/10 transition-colors">
                  <Users className="text-[#3C74FF] mb-2" size={24} />
                  <h4 className="text-white font-semibold mb-1">Partnership</h4>
                  <p className="text-white/70 text-sm">Building lasting relationships</p>
                </div>
                <div className="bg-white/5 rounded-xl p-4 hover:bg-white/10 transition-colors">
                  <Award className="text-[#3C74FF] mb-2" size={24} />
                  <h4 className="text-white font-semibold mb-1">Excellence</h4>
                  <p className="text-white/70 text-sm">Premium quality in every project</p>
                </div>
              </div>
            </div>

            {/* Feature Image */}
            <div className="relative rounded-3xl overflow-hidden group">
              <img 
                src="https://customer-assets.emergentagent.com/job_hyperlink-frontend/artifacts/n67t7h01_WhatsApp%20Image%202025-11-08%20at%2002.29.31_bb5ce4a9.jpg"
                alt="Technology Infrastructure"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#18246F]/80 via-transparent to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6">
                  <p className="text-[#18246F] font-semibold mb-2">20+ Years of Excellence</p>
                  <p className="text-gray-600 text-sm">Delivering world-class IT solutions across Ghana and beyond</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Statement - Amazing Redesign */}
      <section className="py-20 bg-white relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle, #3C74FF 1px, transparent 1px)',
            backgroundSize: '50px 50px'
          }}></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          {/* Section Header */}
          <div className="text-center mb-16">
            <Badge className="mb-4 bg-[#3C74FF]/10 text-[#3C74FF] border-[#3C74FF]/20">Our Approach</Badge>
            <h2 className="text-4xl md:text-5xl font-bold text-[#18246F] mb-4">
              How We Deliver <span className="text-[#3C74FF]">Excellence</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Our delivery teams provide advisory services, technical expertise, and proven adoption strategies that ensure project success across all industries
            </p>
          </div>

          {/* Hero Image with Floating Cards */}
          <div className="relative mb-16">
            {/* Central Image */}
            <div className="relative rounded-3xl overflow-hidden shadow-2xl max-w-4xl mx-auto">
              <img 
                src="https://customer-assets.emergentagent.com/job_hyperlink-frontend/artifacts/vkf3r5oa_WhatsApp%20Image%202025-11-08%20at%2002.29.28_782b00b4.jpg"
                alt="Team Meeting"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#18246F]/60 via-transparent to-transparent"></div>
            </div>

            {/* Floating Cards Around Image */}
            {/* Top Left */}
            <div className="absolute -top-8 -left-8 hidden lg:block">
              <div className="bg-gradient-to-br from-[#3C74FF] to-[#616EB7] text-white p-6 rounded-2xl shadow-2xl w-72 hover:scale-105 transition-transform duration-300 animate-fadeInUp">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="bg-white/20 rounded-lg p-2">
                    <Lightbulb size={24} />
                  </div>
                  <h3 className="font-bold text-lg">Advisory Services</h3>
                </div>
                <p className="text-white/90 text-sm">
                  Expert guidance and strategic planning for your technology initiatives
                </p>
              </div>
            </div>

            {/* Top Right */}
            <div className="absolute -top-8 -right-8 hidden lg:block" style={{ animationDelay: '0.2s' }}>
              <div className="bg-gradient-to-br from-[#616EB7] to-[#3C74FF] text-white p-6 rounded-2xl shadow-2xl w-72 hover:scale-105 transition-transform duration-300 animate-fadeInUp">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="bg-white/20 rounded-lg p-2">
                    <Target size={24} />
                  </div>
                  <h3 className="font-bold text-lg">Business Methodology</h3>
                </div>
                <p className="text-white/90 text-sm">
                  Detailed assessments without compromising quality
                </p>
              </div>
            </div>

            {/* Bottom Left */}
            <div className="absolute -bottom-8 -left-8 hidden lg:block" style={{ animationDelay: '0.4s' }}>
              <div className="bg-gradient-to-br from-purple-600 to-purple-700 text-white p-6 rounded-2xl shadow-2xl w-72 hover:scale-105 transition-transform duration-300 animate-fadeInUp">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="bg-white/20 rounded-lg p-2">
                    <Settings size={24} />
                  </div>
                  <h3 className="font-bold text-lg">Agile Process</h3>
                </div>
                <p className="text-white/90 text-sm">
                  Scrum methodology for effective product development
                </p>
              </div>
            </div>

            {/* Bottom Right */}
            <div className="absolute -bottom-8 -right-8 hidden lg:block" style={{ animationDelay: '0.6s' }}>
              <div className="bg-gradient-to-br from-green-600 to-green-700 text-white p-6 rounded-2xl shadow-2xl w-72 hover:scale-105 transition-transform duration-300 animate-fadeInUp">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="bg-white/20 rounded-lg p-2">
                    <CheckSquare size={24} />
                  </div>
                  <h3 className="font-bold text-lg">Quality Assurance</h3>
                </div>
                <p className="text-white/90 text-sm">
                  SLA agreements for all projects with defined criteria
                </p>
              </div>
            </div>
          </div>

          {/* Bottom Features Grid - Mobile Friendly */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-24 lg:mt-32">
            {/* Maintenance */}
            <div className="group bg-gradient-to-br from-white to-gray-50 rounded-2xl p-6 border-2 border-gray-100 hover:border-[#3C74FF] transition-all duration-300 hover:shadow-xl">
              <div className="bg-gradient-to-br from-[#3C74FF]/10 to-[#616EB7]/10 w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <Share2 className="text-[#3C74FF]" size={28} />
              </div>
              <h3 className="font-bold text-[#18246F] text-lg mb-2">Maintenance & Support</h3>
              <p className="text-gray-600 text-sm mb-4">
                Our Support Center assigns unique request numbers to streamline communication and ensure rapid assistance
              </p>
              <div className="flex items-center text-[#3C74FF] text-sm font-semibold">
                <span>24/7 Support</span>
                <ArrowRight className="ml-2" size={16} />
              </div>
            </div>

            {/* Professional Team */}
            <div className="group bg-gradient-to-br from-white to-gray-50 rounded-2xl p-6 border-2 border-gray-100 hover:border-[#616EB7] transition-all duration-300 hover:shadow-xl">
              <div className="bg-gradient-to-br from-[#616EB7]/10 to-[#3C74FF]/10 w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <Briefcase className="text-[#616EB7]" size={28} />
              </div>
              <h3 className="font-bold text-[#18246F] text-lg mb-2">Certified Professionals</h3>
              <p className="text-gray-600 text-sm mb-4">
                Experience across many industries, market segments, and geographies with proven track records
              </p>
              <div className="flex items-center text-[#616EB7] text-sm font-semibold">
                <span>Expert Team</span>
                <ArrowRight className="ml-2" size={16} />
              </div>
            </div>

            {/* Global Delivery */}
            <div className="group bg-gradient-to-br from-white to-gray-50 rounded-2xl p-6 border-2 border-gray-100 hover:border-purple-600 transition-all duration-300 hover:shadow-xl md:col-span-2 lg:col-span-1">
              <div className="bg-gradient-to-br from-purple-600/10 to-purple-700/10 w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <Globe className="text-purple-600" size={28} />
              </div>
              <h3 className="font-bold text-[#18246F] text-lg mb-2">Global Delivery</h3>
              <p className="text-gray-600 text-sm mb-4">
                Proven adoption strategies ensuring successful project delivery across multiple continents
              </p>
              <div className="flex items-center text-purple-600 text-sm font-semibold">
                <span>Worldwide Reach</span>
                <ArrowRight className="ml-2" size={16} />
              </div>
            </div>
          </div>

          {/* Stats Banner */}
          <div className="mt-16 bg-gradient-to-r from-[#18246F] via-[#3C74FF] to-[#616EB7] rounded-3xl p-8 md:p-12 text-white relative overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <Hexagon className="absolute top-4 right-4" size={100} />
              <Hexagon className="absolute bottom-4 left-4" size={80} />
            </div>
            <div className="relative z-10 grid md:grid-cols-4 gap-8 text-center">
              <div>
                <div className="text-4xl font-bold mb-2">100%</div>
                <div className="text-white/80 text-sm">Project Success Rate</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">24/7</div>
                <div className="text-white/80 text-sm">Support Available</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">ISO</div>
                <div className="text-white/80 text-sm">9001:2015 Certified</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">150+</div>
                <div className="text-white/80 text-sm">Solutions Delivered</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Business Solutions - Page 7 Design */}
      <section id="services" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h2 className="text-4xl font-bold text-[#18246F] mb-8">Business Solutions We Provide</h2>
              
              <p className="text-gray-700 mb-8 leading-relaxed text-justify">
                HYPERLINK NETWORK SYSTEMS (HNS) is an information systems company specializing in network and telecommunication management. Over the years, we have delivered custom-fit solutions across the country and take pride in being one of the top IT solution providers.
              </p>

              <div className="relative">
                <div className="w-80 h-80 mx-auto">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/gh6njfbx_image.png"
                    alt="HNS Services Diagram"
                    className="w-full h-full object-contain animate-spin-slow"
                  />
                </div>
              </div>
            </div>

            <div className="space-y-6">
              {businessSolutions.map((solution, index) => {
                const Icon = solution.icon;
                return (
                  <div key={index} className="bg-[#3C74FF] text-white p-6 rounded-xl hover-lift">
                    <div className="flex items-start space-x-4">
                      <Icon className="flex-shrink-0 mt-1" size={28} />
                      <div>
                        <h3 className="text-xl font-bold mb-2">{solution.title}</h3>
                        <p className="text-white/90 text-sm text-justify">{solution.description}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* What Else We Offer - Page 8 Design */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-[#18246F] mb-4 text-center">What Else We Offer</h2>
          <p className="text-center text-gray-600 mb-12 text-lg">Technology with Infinite Solutions...</p>
          
          <div className="grid md:grid-cols-2 gap-8">
            {/* Telecom Solutions */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl overflow-hidden">
              <div className="p-8">
                <div className="flex items-center space-x-4 mb-4">
                  <div className="bg-green-600 p-3 rounded-lg">
                    <Phone className="text-white" size={28} />
                  </div>
                  <h3 className="text-2xl font-bold text-[#18246F]">Telecom Solutions</h3>
                </div>
                <p className="text-gray-700 mb-6 text-justify">
                  We build, secure, and maintain telecom infrastructures. We also implement health and safety protocols to ensure environmental quality when we build.
                </p>
                <p className="text-gray-600 text-sm text-justify">
                  With more than 15 years of expertise, we excel in constructing secure telecom and network infrastructure worldwide, with a specialized focus on challenging terrains.
                </p>
              </div>
              <div className="h-48">
                <img 
                  src="https://customer-assets.emergentagent.com/job_hyperlink-frontend/artifacts/jerhokdf_teli.jpg"
                  alt="Telecom"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Solar Solutions */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl overflow-hidden">
              <div className="h-48">
                <img 
                  src="https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/0g80y1rm_solar.jpg"
                  alt="Solar"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-8">
                <div className="flex items-center space-x-4 mb-4">
                  <div className="bg-yellow-500 p-3 rounded-lg">
                    <Sun className="text-white" size={28} />
                  </div>
                  <h3 className="text-2xl font-bold text-[#18246F]">Solar Solutions</h3>
                </div>
                <p className="text-gray-700 text-justify">
                  We design, install, and maintain high-efficiency solar energy systems. We also follow strict safety and environmental protocols to ensure sustainable and responsible project execution from start to finish.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Clients - Page 9 Design */}
      <section id="clients" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <Badge className="mb-4 bg-[#3C74FF]/10 text-[#3C74FF] border-[#3C74FF]/20">Trusted By</Badge>
            <h2 className="text-4xl font-bold text-[#18246F] mb-4">Some of <span className="text-[#3C74FF]">Our Clients</span></h2>
            <p className="text-gray-600">Trusted by leading organizations across multiple industries</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
            {clientLogos.map((client, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all hover-lift flex items-center justify-center min-h-[120px] group">
                <img 
                  src={client.logo} 
                  alt={client.name} 
                  className="h-16 w-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300" 
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Let's Connect - Page 10 Design */}
      <section id="contact" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h2 className="text-4xl font-bold text-[#18246F] mb-6">Let's Connect</h2>
              
              <p className="text-gray-700 mb-8 leading-relaxed">
                We're happy to answer any questions you may have and help you determine which of our services best fit your needs.
              </p>

              <div className="mb-8">
                <h3 className="text-xl font-bold text-[#18246F] mb-4">We are:</h3>
                <div className="grid grid-cols-2 gap-3">
                  {['Client-oriented', 'Independent', 'Competent', 'Results-driven', 'Problem-solving', 'Transparent'].map((attr, index) => (
                    <div key={index} className="flex items-center space-x-2">
                      <CheckCircle className="text-blue-600" size={18} />
                      <span className="text-gray-700 text-sm">{attr}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Offices in Two Columns */}
              <div className="grid md:grid-cols-2 gap-6">
                {/* USA Office */}
                <div className="p-6 bg-gray-50 rounded-xl">
                  <h3 className="font-bold text-[#18246F] mb-3 flex items-center">
                    <MapPin className="mr-2" size={20} />
                    USA Office
                  </h3>
                  <p className="text-gray-700 text-sm mb-2">10432 Balls Ford Rd, Suite 300</p>
                  <p className="text-gray-700 text-sm mb-2">Manassas, VA 20109</p>
                  <p className="text-gray-700 text-sm mb-2">Phone: +1 (571) 406-4203</p>
                  <p className="text-gray-700 text-sm">Email: info@hnsgh.com</p>
                </div>

                {/* Ghana Office */}
                <div className="p-6 bg-gray-50 rounded-xl">
                  <h3 className="font-bold text-[#18246F] mb-3 flex items-center">
                    <MapPin className="mr-2" size={20} />
                    Ghana Office
                  </h3>
                  <p className="text-gray-700 text-sm mb-2">Ghana Science and Museum, Block 8</p>
                  <p className="text-gray-700 text-sm mb-2">Barnes Road, Adabraka</p>
                  <p className="text-gray-700 text-sm mb-2">Accra, Ghana - West Africa</p>
                  <p className="text-gray-700 text-sm mb-2">Phone: (+233) 0302-230235</p>
                  <p className="text-gray-700 text-sm">Fax: (+233) 0302-230261</p>
                </div>
              </div>
            </div>

            <div>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                  <Input 
                    type="text"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    required
                    className="border-gray-300 focus:border-[#18246F] focus:ring-[#18246F]"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                  <Input 
                    type="email"
                    placeholder="your.email@example.com"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    required
                    className="border-gray-300 focus:border-[#18246F] focus:ring-[#18246F]"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Subject</label>
                  <Input 
                    type="text"
                    placeholder="Project Inquiry"
                    value={formData.subject}
                    onChange={(e) => setFormData({...formData, subject: e.target.value})}
                    required
                    className="border-gray-300 focus:border-[#18246F] focus:ring-[#18246F]"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                  <Textarea 
                    placeholder="Tell us about your project..."
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    required
                    rows={6}
                    className="border-gray-300 focus:border-[#18246F] focus:ring-[#18246F]"
                  />
                </div>
                <Button type="submit" size="lg" className="w-full bg-[#3C74FF] hover:bg-[#2d5fd9] text-white">
                  Send Message
                </Button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#18246F] text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_hyperlink-network/artifacts/0iy7o1s0_cropped-HYPERLINK_transperat.webp"
                  alt="HNS Logo"
                  className="h-12 w-12 object-contain"
                />
                <div>
                  <h3 className="text-xl font-bold">HNS</h3>
                  <p className="text-xs text-gray-300">...technology with infinite solutions</p>
                </div>
              </div>
              <p className="text-sm text-gray-300 leading-relaxed mb-4">
                Leading the ICT industry with reliable information systems solutions. ISO 9001:2015 certified with over 20 years of excellence in technology delivery.
              </p>
              <div className="flex items-center space-x-2 text-sm text-gray-400">
                <Award size={16} />
                <span>Trusted by 50+ Organizations</span>
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2 text-sm text-gray-300">
                <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
                <li><Link to="/services" className="hover:text-white transition-colors">Services</Link></li>
                <li><button onClick={() => scrollToSection('clients')} className="hover:text-white transition-colors">Clients</button></li>
                <li><button onClick={() => scrollToSection('contact')} className="hover:text-white transition-colors">Contact</button></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Services</h4>
              <ul className="space-y-2 text-sm text-gray-300">
                <li>Managed Services</li>
                <li>Network Solutions</li>
                <li>Software Development</li>
                <li>Cloud Solutions</li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Contact</h4>
              <ul className="space-y-2 text-sm text-gray-300">
                <li className="flex items-start">
                  <Mail size={16} className="mr-2 mt-1 flex-shrink-0" />
                  <span>info@hnsgh.com</span>
                </li>
                <li className="flex items-start">
                  <MapPin size={16} className="mr-2 mt-1 flex-shrink-0" />
                  <span>Accra, Ghana | Manassas, VA USA</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-600 pt-8 text-center text-sm text-gray-300">
            <p>&copy; {new Date().getFullYear()} Hyperlink Network Systems Limited. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Floating Call Button */}
      <a 
        href="tel:+15714064203"
        className="fixed bottom-8 left-8 bg-[#3C74FF] hover:bg-[#2d5fd9] text-white rounded-full p-4 shadow-2xl z-50 flex items-center gap-3 group transition-all duration-300 hover:scale-110"
      >
        <Phone size={24} className="animate-pulse" />
        <span className="hidden group-hover:inline-block text-sm font-semibold whitespace-nowrap">
          +1 (571) 406-4203
        </span>
      </a>
    </div>
  );
};

export default Home;
